import _ from 'lodash'

// path, paramater 만 지원
export default {
  name: 'RuleCustom',
  props: ['origin', 'name', 'is_setup', 'example', 'type'],
  computed: {},
  watch: {
    origin() {
      // 기존 값이 변경시 해당 데이터 업데이트, 컴포넌트로 사용시 필요
      this.model = this.origin
    }
  },
  data: () => {
    return {
      explain_params : false,
      explain_path :false,
      model : '',
      ex : ''
    }
  },
  methods: {
    explain() {
      // 모달용
      console.log(`explain_${this.type}`)
      this[`explain_${this.type}`] =  this[`explain_${this.type}`] != undefined ? true : false
    },
    refresh() {
      // some action here
      this.$parent.$emit("refresh")
    },
    update($value, key) {
      this.$parent.$emit('update', $value, key)
      location.hostname == 'localhost' ? console.info('update RuleCustom => parent', $value, key) : ''
    },
  },
  created: function() {   console.log('RuleCustom.vue', 'created'); },
  destroyed: function() { console.log('RuleCustom.vue', 'destroyed'); },
  mounted: function() {
    console.log('RuleCustom.vue', 'mounted');
    this.model = this.origin
    this.ex = this.example ? _.join(this.example.split(','), '\n') : ''
  }
}
